export default __webpack_public_path__ + "static/media/i_bus-low_gy_tagless.8a142009.svg";